import WidgetContent from "./widgetContent/WidgetContent";

const Widget = ({ className = "", width, height, color, titleColor = "black", children, links = [], mainLink, title, icon, contentScrollable = true, onClick }) => {

    const scrollHeight = "100%";

    return (
        <div className={className}>
            <WidgetContent
                className={className}
                width={width}
                height={height}
                color={color}
                title={title}
                icon={icon}
                titleColor={titleColor}
                links={links}
                mainLink={mainLink}
                contentScrollable={contentScrollable}
                scrollHeight={scrollHeight}
                onClick={onClick}
            >
                {children}
            </WidgetContent>
        </div>
    );
};

export default Widget;
